import { useTranslation } from 'react-i18next';

import { useAuthUser } from 'auth/hooks';
import { Error, PageLayout } from 'core/components';
import { StatusCode } from 'core/constants';
import { PartFinderCatalog } from 'partFinder/components';
import { canAccessPartFinder } from 'partFinder/utils';

export const PartFinderCatalogPage = () => {
  const { t } = useTranslation();

  const { user, isLoading } = useAuthUser();

  const title = t('titlePartFinderCatalog');

  if (isLoading) {
    return <PageLayout title={title} />;
  }

  if (!canAccessPartFinder(user)) {
    return (
      <PageLayout title={title}>
        <Error statusCode={StatusCode.ACCESS_DENIED} />
      </PageLayout>
    );
  }

  return (
    <PageLayout title={title}>
      <PartFinderCatalog />
    </PageLayout>
  );
};
